import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[backgroundImage]',
    standalone: true
})
export class BackgroundImageDirective implements AfterViewInit, OnChanges {

    @Input() url: string;
    @Input() size: string;
    @Input() position: string;

    private el: HTMLElement;

    constructor(el: ElementRef) {
        this.el = el.nativeElement;
    }

    ngAfterViewInit(): void {
        this.el.style.backgroundImage = `url(${this.url})`;
        this.el.style.backgroundRepeat = 'no-repeat';
        this.el.style.backgroundSize = this.size || 'contain';
        this.el.style.backgroundPosition = this.position || 'center';
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.el.style.backgroundImage = `url(${this.url})`;
        this.el.style.backgroundRepeat = 'no-repeat';
        this.el.style.backgroundSize = this.size || 'contain';
        this.el.style.backgroundPosition = this.position || 'center';
    }

}
